import api from './api';

export const getAllBiometrics = async () => {
  return await api.get('biometrics');
};

export const saveBiometrics = async (biometrics: any) => {
  return await api.post('biometrics', biometrics);
};
